import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';

@Injectable({
  providedIn: 'root',
})
export class InstantFeedbackService {
  constructor(private apiCoreService: APICoreService) {}

  getSmartFeedback(
    evidenceId: number
  ): Observable<{ ai_instant_feedback_id: number } | { error: string }> {
    return this.apiCoreService
      .getRequest(`ai/evidence-feedback?evidence_id=${evidenceId}`)
      .pipe(
        catchError((err) => {
          throw err;
        })
      );
  }

  getCardFeedback(
    compId: number,
    artifact: File | null,
    narrative: string | null
  ): Observable<{ ai_instant_feedback_id: number } | { error: string }> {
    const formData = new FormData();
    if (artifact) {
      formData.append('file', artifact);
    }
    if (narrative) {
      formData.append('narrative', narrative);
    }
    formData.append('competency_id', compId.toString());
    return this.apiCoreService
      .postFormRequest('ai/smart-feedback', formData)
      .pipe(
        catchError((err) => {
          throw err;
        })
      );
  }
}
